import styled from 'styled-components';

export const Wrapper = styled.div`
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
`;

export const Container = styled.div`
  border-radius: 10px;
  //max-width: 500px;
`;

export const Text = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #000;
  text-align: left;
`;

export const GreyText = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #7d7d7d;
  text-align: left;
`;

export const TextTimer = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #000;
  text-align: left;
`;

export const Form = styled.form``;

export const HeaderForgetContainer = styled.div`
  display: block;
  width: 100%;
  text-align: right;
`;
export const HeaderForget = styled.div`
  text-align: right;
  display: inline-block;
  color: #4378ff;
  font-size: 14px;
  margin-right: 20px;
  margin-bottom: 10px;
  cursor: pointer;
`;
